<template>
    <div class="download max-content">
        <!-- <van-nav-bar
            title="资料下载"
            left-arrow
            @click-left="onClickLeft"
        /> -->
        <top title="资料下载" color="#090969"></top>
        <div class="buttons" >
            <!-- <img src="./images/15.png" @click="goInvite(4389)"/> -->
            <img src="./images/17.png" @click="goInvite(4390)"/>
            <img  @click="skip()"  src="./images/16.png" alt="">
        </div>
        <img src="./images/bottom.png" class="bottom"/>
    </div>
</template>

<script>
import Top from '@/pages/VascularSystem/components/Top.vue'
import { ButtonDetail } from '../../../config/interface.js'
export default {
    components:{
        Top
    },
    data(){
        return{
            button_id:'',
            meeting_id:'790',

        }
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.meeting_id=this.$route.query.meeting_id
        this.getButtonData();
    },
    methods:{
        goDetail(type){

        },
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
        skip(){
			this.$router.push('/vascularNews/meeting/ppt?meeting_id='+this.meeting_id+'&button_id=4851')
            
        },
        onClickLeft(){
            this.$router.go(-1)
        },
        goInvite(id){
			this.$router.push('./invite?meeting_id='+this.meeting_id+'&id='+id)
        }
    }
}
</script>

<style lang="scss" scoped>
.download{
    width:100%;
    height: 100vh;
    background: #b6f0fa5e;
    position: relative;
    .buttons{
        padding:30px 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        img{
            width: 100%;
            margin-bottom: 4%;
            border-radius:10px;
        }
    }
    .bottom{
        position: absolute;
        width:94%;
        bottom: 20px;
        left: 3%;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting790/download.vue